<div class="amw-loader"
  *ngIf="visible"
  [ngClass]="{'amw-loader--cover':cover,'amw-loader--cover-element':elementCover}">
  <div *ngIf="cover || elementCover"
  [ngClass]="{'amw-loader__cover':cover,'amw-loader__cover-element':elementCover}"></div>
  <div class="amw-loader__spinner amw-spinner"></div>
  <div class="amw-loader__label">
    {{ text }}
  </div>
</div>
